import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';
import { HouseholdService } from 'app/services/household-service';
import { ToastrService } from 'ngx-toastr';
import { DialogEditHouseholdComponent } from '../../edit/household-edit-dialog';

@Component({
  selector: 'household-multiple-housing-units-report',
  templateUrl: './household-multiple-housing-units.component.html',
  styleUrls: ['./household-multiple-housing-units.component.scss']
})
export class HouseholdMultipleHousingUnitsComponent implements OnInit {
  loading: boolean = false;  
  size: number = 0;
  sizeHousingUnits: number = 0;
  searchResults: IHousehold[] = [];
  searchResultsHousingUnits: IHousingUnit[] = [];
  
  displayedColumns: string[] = ['id','address1','city','zip','county'];
  dataSource = new MatTableDataSource<IHousehold>(this.searchResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
 
  constructor(private householdService: HouseholdService,
    public dialog: MatDialog,private sharedService: SharedService,
    private toastr: ToastrService ) { 
  }

  ngOnInit(): void {
    this.loadReport();  
  }
  
  loadReport() {
    this.loading = true;

    this.householdService.getMultipleHousingUnitsReport().subscribe(
      result => {
        this.searchResults = result;
        this.size = result.length;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<IHousehold>(this.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loading = false;
      }
    );
  }
 
  editHousehold(householdId: number) {
      const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
        width: '90%',
        data: householdId,
      }); 
    }
   
}